import { useMemo, useState } from 'react';
import { SearchSectionForm } from 'src/components/common/form/search/SearchSectionForm';
import { SearchCodeModalForm } from 'src/components/common/form/search/SearchCodeModalForm';
import { SearchYearSingleForm } from 'src/components/common/form/search/SearchYearSingleForm';
import useUiuxStore from 'src/store/useUiuxStore';
import { useInfoFormEvents } from 'src/hooks/useInfoFormEvents';
import { InfoCodeSearchFieldConfig } from 'src/types/info-form';
import { useEQM3020_R01Store, defaultEQM3020_R01Filter } from './Store_EQM3020_R01';

const parseYearToDate = (year: number): Date | undefined => {
	if (!Number.isFinite(year) || year < 1000 || year > 9999) return undefined;
	return new Date(year, 0, 1);
};

export const SearchSection_EQM3020_R01 = () => {
	const { EQM3020_R01Filter, setEQM3020_R01Filter } = useEQM3020_R01Store();
	const { setCodeSearchModalProps } = useUiuxStore();
	const [pickerVisible, setPickerVisible] = useState(false);
	const [pickerPosition, setPickerPosition] = useState({ top: 0, left: 0 });

	const yearValue = useMemo(
		() => parseYearToDate(EQM3020_R01Filter.year),
		[EQM3020_R01Filter.year],
	);

	const eqmFocusId = 'equipmentCd_search';

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'equipmentCd',
			category: '계측기',
			focusId: eqmFocusId,
			responseMapping: {
				equipmentCd: 'equipmentCd',
				equipmentNm: 'equipmentNm',
			},
			extraFilter: () => ({ equipmentType: 'TESTER' }),
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData: EQM3020_R01Filter,
		setEditData: setEQM3020_R01Filter,
		defaultData: defaultEQM3020_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'EQM3020_R01_search',
	});

	return (
		<SearchSectionForm>
			<SearchYearSingleForm
				label="연도"
				visible={pickerVisible}
				setVisible={setPickerVisible}
				value={yearValue}
				onChange={(d) => {
					if (d) setEQM3020_R01Filter({ year: d.getFullYear() });
				}}
				pickerPosition={pickerPosition}
				setPickerPosition={setPickerPosition}
			/>
			<SearchCodeModalForm
				label="계측기"
				value={EQM3020_R01Filter.equipmentCd}
				valueLabel={EQM3020_R01Filter.equipmentNm}
				handleFoucsId={eqmFocusId}
				onChange={getFieldHandlers('equipmentCd').onChange}
				onDoubleClick={getFieldHandlers('equipmentCd').onDoubleClick}
				onKeyDown={getFieldHandlers('equipmentCd').onEnterKeyDown}
			/>
		</SearchSectionForm>
	);
};
